import React from 'react'
import './../App.css'
import './../style/home.css'
import { BsArrowRight } from 'react-icons/bs'
import Tabs from './../components/tab/Tabs'
import home_section1_img from './../Images/ISKILLRES-01-20211012122521-661afd9dc8234f6633212d07184c65db.png'
import rotateicon from './../Images/download.png'
import home_section2_img from './../Images/how-its-work-74cb4658b01e7ca4edb2d0ddccdc8482.png'
import serviesbox1img from './../Images/software-development-fd2689b86be84f80acea358918d09549.png'
import serviesbox2img from './../Images/web-60a248a5620f89fa664ec599a06b323d.png'
import serviesbox3img from './../Images/wp-c890502f362c25598ed2bbaa289e2e8b.png'
import serviesbox4img from './../Images/download (1).png'
import serviesbox5img from './../Images/graphics-51a2a3702127f124ff74126c092e4a95.png'
import serviesbox6img from './../Images/online-shopping-9c348a2a4d0fc279416079a6ca0a4a77.png'
import vectorshape from './../Images/vector-shape6-571a738d8be912721121ee3a3d3a05a3.png'
import Projectstart from '../components/projectstart/Projectstart'

export default function Home() {

  return (
    <>
      <section className="home_section-1">
        <div className="container">
          <div className='row align-items-center'>
            <div className="col-lg-6 col-md-12">
              <div className="home_section1_banner_content">
                <h1>iHunar - IT Company</h1>
                <p>IT services provider company managed by highly experienced information technology professionals.</p>
                <div className="button_main">
                  <button className='button'>Get in Touch</button>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <img src={home_section1_img} />
            </div>
          </div>
        </div>
      </section>
      <section className='home_section-2 ptb-100'>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className='sub-title'><img src={rotateicon} /> PEOPLE LOVE US</div>
              <h2>Why Should you choose iHunar?</h2>
              <p>We have been working since 2020, as an IT services provider company, we are developing software applications and mobile apps, designing websites, branding businesses for clients all over the world.</p>
            </div>
            <div className="col-lg-6 col-md-12">
              <img src={home_section2_img} />
            </div>
          </div>
        </div>
      </section>
      <section className='home_section-3 pt-100 pb-70' style={{ backgroundColor: "#fafafb" }}>
        <div className="container">
          <div className="section_title">
            <div className='sub-title'><img src={rotateicon} /> our services</div>
            <h2>We Are Offering All sort of IT Solutions Services</h2>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="services_box">
                <div className="icon">
                  <img src={serviesbox1img} style={{ width: "60px", height: "60px" }} />
                </div>
                <h3>Software Development</h3>
                <p>Making software programs are not an easy job, but our Software developers are very experienced and familiar with all modern tools</p>
                <a href="./Softwaredevelopment.js" className='read-more-btn'>View Details <BsArrowRight /></a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="services_box">
                <div className="icon">
                  <img src={serviesbox2img} style={{ width: "60px", height: "60px" }} />
                </div>
                <h3>Web Development</h3>
                <p>Our Flexible and Expert IT team can turn your local or international business or idea into Responsive and attractive website.</p>
                <a href="./Webdevelopment.js" className='read-more-btn'>View Details <BsArrowRight /></a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="services_box">
                <div className="icon">
                  <img src={serviesbox3img} style={{ width: "60px", height: "60px" }} />
                </div>
                <h3>WordPress</h3>
                <p>WordPress is a Simplest but most powerful and popular tool. You can easily manage your site, even if you don't have any IT experience.</p>
                <a href="./Wordpress.js" className='read-more-btn'>View Details <BsArrowRight /></a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="services_box">
                <div className="icon">
                  <img src={serviesbox4img} style={{ width: "60px", height: "60px" }} />
                </div>
                <h3>Mobile App Development</h3>
                <p>Our Mobile App Developers are adopting modern user based methodologies, and technologies for building both IOS AND Android mobile apps.</p>
                <a href="./Mobileappdevelopment.js" className='read-more-btn'>View Details <BsArrowRight /></a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="services_box">
                <div className="icon">
                  <img src={serviesbox5img} style={{ width: "60px", height: "60px" }} />
                </div>
                <h3>Product & Design</h3>
                <p>Product designing is exactly what end-user see. Our creative graphics designers will make a suitable and fresh design ideas for your product.</p>
                <a href="./Productanddesign.js" className='read-more-btn'>View Details <BsArrowRight /></a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="services_box">
                <div className="icon">
                  <img src={serviesbox6img} style={{ width: "60px", height: "60px" }} />
                </div>
                <h3>Ecommerce</h3>
                <p>Our professional Market Expert will solve your problem related to Online Shopping. We will provide you solution related to Amazon and Shopify Stores.</p>
                <a href="./Ecommerce.js" className='read-more-btn'>View Details <BsArrowRight /></a>
              </div>
            </div>
          </div>
        </div>
        <div className="vector-shape">
          <img src={vectorshape} />
        </div>
      </section>
      <section className="home_section-4 pt-100 pb-70">
        <div className="container">
          <div className="section_title">
            <div className='sub-title'><img src={rotateicon} /> technologies</div>
            <h2>Technologies we work with</h2>
          </div>
          <Tabs/>
        </div>

      </section>
      <Projectstart Projecttitle="We Like to Start Your Project With Us" projectdescription="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna." projectbtntext="Get Started"/>
      <section className="home_section-6 ptb-100">
        <div className="container">
          <div className="section_title">
            <div className='sub-title'><img src={rotateicon} /> OUR WORKING PROCESS</div>
            <h2>Greater control over different projects through Agile Methodology.</h2>
            <p>Our major role is customer satisfaction by rapid delivery of softwares.</p>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="home_section6_content">
                <div className="home_section6_items">
                  <div className="count_box">1</div>
                  <h3>Requirements</h3>
                  <p>Our Project Management team collect requirement and analyse them for preparing road map, sprint and initiate plan.</p>
                </div>
                <div className="home_section6_items">
                  <div className="count_box">2</div>
                  <h3>Planning</h3>
                  <p>iHunar Project Management team breakdown the all requirements and set priorities and in the last iterate them for scheduling.</p>
                </div>
                <div className="home_section6_items">
                  <div className="count_box">3</div>
                  <h3>Design</h3>
                  <p>Share architecture spike analysis, design and implement the prototype.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="home_section6_content">
                <div className="home_section6_items">
                  <div className="count_box">4</div>
                  <h3>Development</h3>
                  <p>iHunar Project Management team breakdown the all requirements and set priorities and in the last iterate them for scheduling.</p>
                </div>
                <div className="home_section6_items">
                  <div className="count_box">5</div>
                  <h3>Testing</h3>
                  <p>Team will work on testing, identify defects, and resolve those bugs.</p>
                </div>
                <div className="home_section6_items">
                  <div className="count_box">6</div>
                  <h3>Release & Review</h3>
                  <p>Demonstrate the user's stories, implemented and done to the product owner.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
